import { DashboardModuleListItem, Text } from '@domain-group/suit-theme'

import { ServiceModel } from '@models/types'

interface ServiceProps {
  callbacks?: {
    onClick: () => void,
  },
  entity: ServiceModel,
  selected: boolean,
}

const Service = (props: ServiceProps) => {
  const {
    callbacks,
    entity: { id, title },
    selected,
  } = props

  const { onClick } = callbacks || {}

  return (
    <DashboardModuleListItem
      isChecked={selected}
      onClick={onClick}
      showCheckbox
      title={title}
    >
      <Text color="bodyFontLightColor">ID #{id}</Text>
    </DashboardModuleListItem>
  )
}

export default Service
